<template>
	<div class="update">
		<!-- <h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">礼品卡 </h2> -->

		<!-- <div class="search" @keyup.enter="getList">
			<el-input class="search-input" v-model="nowMobile" placeholder="请输入手机号">
				<div class="search-icon" slot="prefix">
					<i class="el-icon-search"></i>
				</div>
			</el-input>
			<el-button @click="getList" :loading="submiting" class="qjc-fts-16">筛选</el-button>
		</div> -->
		<div class="sanya_wrap">
			<el-table
				ref="cardTabel"
				:data="list"
				class="list qjc-fts-14"
				 >
				
				<!-- :height="mainHeight" -->
				<el-table-column prop="id" label="id编号" class-name="mobile"></el-table-column>
				<el-table-column prop="mobile" label="手机号" class-name="mobile"></el-table-column>
				
				<el-table-column prop="created_at" label="操作时间" class-name="created_at">
					<template slot-scope="scope">
						{{ scope.row.created_at ? scope.row.created_at : '--' }}
					</template>
				</el-table-column>
				<el-table-column prop="action" label="操作" class-name="action">
					<template slot-scope="scope">
						<el-button class="btn-text" @click="lookReport(scope.row.id)" type="text">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="iframe_wrap" id="iframe_wrap">
				<iframe class="iframe_style" id="iframe" name="iframeeducation" :src="iframeSrc" frameborder="0"></iframe>
			</div>
		</div>
		
	
			<!-- 分页组件 -->
			<el-pagination
				class="pagination qjc-texta-c"
				
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper"
				hide-on-single-page
				:current-page.sync="pageData.page"
				:page-count="pageData.pagecount"
				:page-size="pageData.pagesize"
				:total="pageData.count"
				@current-change="pageChange"
			></el-pagination>
	</div>
</template>

<script>
import { getSanyaList } from '@/utils/axios.js';

export default {
	name: 'mainGiftCard',
	data() {
		return {
			submiting: false, // 正在请求
			list: [], //列表
			pageData: {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 15 // 每页条数
			},
			nowMobile: '',
			isShow: false,
			iframeSrc: '',
			mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 250 ,// 容器最小高度(去除header高度)
		};
	},

	mounted() {
		this.getList();
	},
	components: {},
	watch: {},
	methods: {
	
		//获取列表信息
		getList() {
			// 正在请求
			this.submiting == true;

			getSanyaList({
				page: this.pageData.page,
				pagesize: this.pageData.pagesize
			}).then(res => {
				// 请求成功
				this.submiting == false;
				if (res.code == 200) {
					this.list = res.data.data;
					// 分页
					var pager = res.data.pager;
					for (var key in pager) {
						pager[key] = parseInt(pager[key]);
					}
					this.pageData = pager;
				} else {
					this.$myAlert({
						type: 'fail',
						content: res.msg
					});
				}
			});
		},
		
		// 列表切换
		pageChange(page) {
			this.pageData.page = page;
			this.getList();
		},
		lookReport(id) {
			var url = window.location.href;
			this.iframeSrc = url.match(/main.medinbd/) ? 'https://m.main.medinbd.com/#/sanya/pcresult?id=' + id : 'http://mtest.lao5.cn/#/sanya/pcresult?id=' + id;
			// this.iframeSrc = url.match(/main.medinbd/) ? 'https://m.main.medinbd.com/#/sanya/pcresult?id=' + id : 'http://192.168.2.6:8082/#/sanya/pcresult?id=' + id;
			let box = document.getElementById('iframe_wrap');
				box.innerHTML = '';
				let iframe = document.createElement('iframe');
				iframe.src = this.iframeSrc;
				iframe.style.width = '3.3rem';
				iframe.style.height = '5rem';
				box.appendChild(iframe);
			
			
		},
	}
};
</script>

<style scoped>
.search >>> .el-input__inner {
	height: 34px;
	line-height: 14px;
	font-size: 14px;
	padding: 10px 30px;
	/* background-color: #fafbfc; */
}

.list >>> .el-table__body,
.list >>> .el-table__footer,
.list >>> .el-table__header {
	table-layout: auto;
}
.list >>> .operate .cell {
	width: 84px;
	padding-left: 16px;
}
.list >>> .list-header {
	background-color: #fafbfc;
}
.list >>> .list-header .cell {
	line-height: 16px;
}
.list >>> .el-button--text:active {
	color: #fff;
}
.list >>> .el-button:active {
	background-color: rgba(91,115,220, 0.5);
}
.update >>> .el-table td, .update >>> .el-table th {
	padding: 0.04rem 0;
}
.pagination >>> button {
	width: 32px;
	height: 32px;
	line-height: 32px;
}
.pagination >>> button .el-icon {
	font-size: 14px;
}
.pagination >>> li {
	width: 32px;
	height: 32px;
	line-height: 32px;
	font-size: 14px;
	font-weight: 400;
	color: #40444d;
	border: 1px solid transparent;
	border-radius: 8px;
	margin: 0 6px;
	padding: 0;
	overflow: visible;
}
.pagination >>> li:hover,
.pagination >>> li.active {
	color: #6681fa;
	font-weight: 600;
	border-color: #6681fa;
	border-left: 1px solid #6681fa;
}

.remarks-tabel >>> input {
	border-width: 0 0 1px 0;
	border-radius: 0;
	padding: 0;
	background-color: transparent;
}
.list >>> input::-webkit-outer-spin-button,
.list >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

.list >>> input[type="number"] {
  -moz-appearance: textfield;
}

</style>
<style lang="scss" scoped>
	.search-input {
		width: 458px;
		height: 34px;
	}
	
	.search-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 26px;
		height: 36px;
	}
	.btn-text {
		padding: 0.1rem;
	}
.update {
	width: 100%;
	height: 100%;
	padding: 28px 24px;
	.back-list {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}

	.search {
		display: flex;
		align-items: center;
		// justify-content: space-between;
		// margin-top: 0.32px;
		
		.search-left {
			display: flex;
			align-items: center;
		}
		
		.search-title {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #525866;
			line-height: 18px;
		}

		.search-line {
			margin: 0 10px;
			color: #777f8f;
		}
		// .el-input {
		// 	width: 165px;
		// }
		.el-button {
			width: 104px;
			height: 34px;
			line-height: 34px;
			font-size: 15px;
			padding: 0;
			margin-left: 16px;
			border: none;
			border-radius: 17px;
		}
	}
	.list {
		color: #777f8f;
		margin-top: 16px;

		.iconfont {
			font-size: 12px;

			&.delete-icon {
				position: relative;
				color: #777f8f;

				&::after {
					position: absolute;
					top: 50%;
					left: 50%;
					width: 100%;
					height: 2px;
					content: '';
					background-color: #ff4c52;
					border-radius: 1px;
					transform: translate(-50%, -50%);
				}
			}
		}
		.update-btn {
			cursor: pointer;
		}
	}
	.pagination {
		margin-left: 200px;
	}

	.remarks-tabel {
		display: flex;
		align-items: center;

		.remarks-val {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #777f8f;
		}

		.remarks-input {
			width: 100px;
		}

		.remarks-icon {
			width: 20px;
			height: 20px;
			margin-left: 10px;
			cursor: pointer;
		}

		.status-tag {
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6681fa;
			margin-left: 16px;
			border: none;
			border-radius: 0;
			background-color: transparent;
		}
	}

	.icon-hover {
		color: #6681fa;
	}
}

.status-tip-text {
	font-size: 14px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #777f8f;
	line-height: 24px;
}

.select-cell {
	// position: fixed;
	// bottom: 28px;
	display: flex;
	align-items: center;
	width: 100%;
	height: 66px;
	padding: 0 30px 0 10px;
	background-color: #ffffff;
}

.check-all {
	margin-right: 20px;
}
.sanya_wrap {
	display: flex;
	
}
.iframe_wrap {
	width: 3.75rem;
	height: 7rem;
	margin-left: 0.2rem;
	margin-right: 0.4rem;
	background: url(../../assets/images/phone_icon.png) no-repeat;
	background-size: 100% 112%;
	padding-top: 0.9rem;
	padding-left: 0.24rem;
}
.iframe_style {
	width: 3.3rem;
	height: 5rem;
}

</style>
